import { Activity } from '../../../pure-js/types/GrooverTypes'
import { StepConfig } from '../helpers/RegisterPageHelper'
import { State } from '../hooks/useAppState'
import { RegisterActionFunctions } from '../hooks/useRegisterActions'
import { isActivityFree } from '../utils/activityUtils'

type Props = {
  state: State
  activity: Activity
  stepConfig: StepConfig[]
  actions: RegisterActionFunctions
}

const CourseRegistrationStep = ({ state, activity, stepConfig, actions }: Props) => {
  return stepConfig
    .filter(({ id }) => {
      // If activeRegisterStep is 0, only show StepZero
      if (state.activeRegisterStep === 0) {
        return id === 0
      }
      // Hide payment step (4) for free events
      if (id === 4 && isActivityFree(activity, state.selectedActivities)) {
        return false
      }
      // If activeRegisterStep > 0, show all steps except StepZero
      return id > 0
    })
    .map(({ id, component: StepComponent, props }) => {
      return <StepComponent key={`registration-step-${id}`} {...props(state, activity, actions)} />
    })
}

export default CourseRegistrationStep
